import React from "react";

export default function ChildSafety() {
  return (
    <div
      style={{
        padding: "40px",
        color: "white",
        background: "#0A0A0A",
        minHeight: "100vh"
      }}
    >
      <h1>Child Safety Policy</h1>

      <p>
        TopNationApp is not directed to children under the age of 13.
      </p>

      <p>
        We do not knowingly collect personal information from children.
      </p>

      <p>
        If you believe that a child has provided us with personal data,
        please contact us and we will remove such information immediately.
      </p>

      <p>
        This app is intended for a general audience and business users.
      </p>

      <p>Contact: topnationapp@gmail.com</p>
    </div>
  );
}
